import gql from 'graphql-tag';

export const accountReferralCreate = gql`
  mutation accountReferralCreate($input: AccountReferralCreateInput!) {
    accountReferralCreate(input: $input) {
      success
    }
  }
`;
